import { render, staticRenderFns } from "./InstanceShareItemOwner.vue?vue&type=template&id=f1c52fcc&scoped=true"
import script from "./InstanceShareItemOwner.vue?vue&type=script&lang=js"
export * from "./InstanceShareItemOwner.vue?vue&type=script&lang=js"
import style0 from "./InstanceShareItemOwner.vue?vue&type=style&index=0&id=f1c52fcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c52fcc",
  null
  
)

export default component.exports